import { useSelector } from "react-redux"
import { getUser } from "../store/auth/auth.selectors"

export const useCan = (permission) => {
  const userData = useSelector(getUser)
  const { permissions } = userData

  if (!permissions) {
    return false
  }

  if (userData?.organization?.name !== "Avakyan Capital") {
    if (permission === "schedule.view") return false
  }

  if (Array.isArray(permission)) {
    return permission.every((p) => permissions.includes(p))
  }

  return permissions.includes(permission)
}
